import React from 'react';

function VerifyMifsSending() {
  return <div>VerifyMifsSending</div>;
}

export default VerifyMifsSending;
